import * as React from 'react';
import { useRouteData } from 'react-static';
import { useDebug } from '../../common/hooks/useDebug';
import { useTranslations } from '../../common/translation';
import { FeaturedBanner } from '../../components/featured-banner/FeaturedBanner';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { SearchResults } from '../../components/search-results/SearchResults';
import { DefaultLayout } from '../default/DefaultLayout';
import { LocaleProps } from '../default/DefaultLayout.props';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const { locale, translatedPaths } = useRouteData<LocaleProps>();
  const { t } = useTranslations(translations, locale);
  const seo = {
    description: '',
  };
  const alt = t('imageAlt', 'WB Water Tower Panoramic shot');
  const imageWithPresets: ImageWithPresets = {
    image: {
      alt,
      src: '/assets/images/banner/press-releases-banner-1920x480.jpg',
    },
    tabletImage: {
      alt,
      src: '/assets/images/banner/press-releases-banner-1920x480-tablet.jpg',
    },
    mobileImage: {
      alt,
      src: '/assets/images/banner/press-releases-banner-1920x480-mobile.jpg',
    },
  };

  useDebug('app:layout:PressReleasesLayout', { props: { locale } });

  return (
    <DefaultLayout locale={locale} seo={seo} translatedPaths={translatedPaths}>
      <HeadTitle title={t('pageTitle', 'Press Releases')} />
      <FeaturedBanner
        headingTag='h1'
        imageWithPresets={imageWithPresets}
        titleProps={{ title: t('bannerTitle', 'Press Releases') }}
      />
      <SearchResults
        hideFacets={true}
        key={locale}
        query='f[0]=type:news_release&qt=%20'
        showCategories={true}
        useTopPadding={true}
        orderField={'releaseDate'}
      />
    </DefaultLayout>
  );
};
